import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ScenariosService from "@services/ScenariosService";
import {
  getScenarioCriteria,
  SCENARIO_DEFAULT_CRITERIA,
} from "@variables";

export const createScenario = createAsyncThunk(
  "scenario/create",
  async ({scenario}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.createScenario({
        scenario,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const current = {
  name: "",
  mask: "",
  doctor_profile_id: null,
  product_ids: [],
  due_date: new Date().toISOString(),
  start_date: new Date().toISOString(),
  finish_date: new Date().toISOString(),
  purpose: "",
  objectives: "",
  key_messages: "",
  keywords: "",
  structure: "",
  script: "",
  phase: null,
  questions: "",
  criteria_weights: SCENARIO_DEFAULT_CRITERIA,
  certification: false,
  badge: "",
};

const initialState = {
  target: current,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const createScenarioSlice = createSlice({
  name: "create-scenario",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setCriteriaWeights(state, action) {
      state.target.criteria_weights = action.payload;
    },
    clearCreateScenario(state, action) {
      const isMayoly = action.payload ?? false;

      return {
        ...initialState,
        target: {
          ...current,
          criteria_weights: getScenarioCriteria(isMayoly),
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(createScenario.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(createScenario.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setIsChanged,
  setTarget,
  setError,
  setStatus,
  setCriteriaWeights,
  clearCreateScenario,
} = createScenarioSlice.actions;
export default createScenarioSlice.reducer;
